import { Carousel, ConfigProvider } from 'antd';
import React from 'react';
import MainHumanBody from './MainHumanBody';
import DepartmentCards from './DepartmentCards';
import { useTranslation } from 'react-i18next';

export default function MainDepartment({ humanbodies, departments }: any) {
    const { t } = useTranslation()
    return (
        <>
            <div className="p-4 flex flex-col">
                <div className='flex'>

                    <p className="font-sans text-sm lg:text-base font-bold  text-custom-dark-blue  p-4 dark:text-white">{t('department.title')}</p>
                </div>
                <p className='dark:text-white font-bold text-sm lg:text-sm p-4 pt-1 font-sans'>
                    {t('ourdepartment.sectiondesc')}
                </p>
            </div>

<MainHumanBody humanbodies={humanbodies} departments={departments} />

        </>
    );
}